import ActionType from '../action.types'

/*
    Reducer function to push data to the store in case of different signin action types
*/

export default function login(
  state = { isLoading: false, companu: {}, user: {}, types: [] },
  action
) {
  switch (action.type) {
    case ActionType.LOGIN_ERROR:
      return {
        error: action.hasError,
        message: action.message,
        isLoading: action.isLoading,
      }
    case ActionType.PASSWORD_ERROR:
      return {
        ...state,
        resetError: action.resetError,
        message: action.message,
        isLoading: action.isLoading,
      }
    case ActionType.UPDATE_USER:
      return { ...state, user: action.user }
    case ActionType.OPERATION_INPROGRESS:
      return {
        ...state,
        isLoading: action.isLoading,
        resetError: action.resetError,
        successMessage: action.successMessage,
      }
    case ActionType.LOGIN_SUCCESS:
      return {
        ...state,
        token: action.token,
        isLoading: action.isLoading,
        customer: action.customer,
        user: action.user,
        company: action.company,
      }
    case ActionType.LOGOUT:
      return {
        token: action.token,
        isLoading: action.isLoading,
        customer: action.customer,
        user: action.user,
      }
    case ActionType.RESET_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        successMessage: action.successMessage,
      }
    case ActionType.LOGIN_AS_CUSTOMER:
      return { ...state, customer: action.customer }
    case ActionType.LOGIN_AS_COMPANY:
      return { ...state, company: action.company, customer: null }
    case ActionType.SET_SURGERY_TYPES:
      return { ...state, types: action.types }
    case ActionType.SET_DEFAULT_FILTER:
      return { ...state, user: { ...state.user, filter: action.filter } }
    case ActionType.UPDATE_USER_VISITED_PAGE: {
      console.log('newww3456')
      return {
        ...state,
        user: {
          ...state.user,
          pagevisited: state.user.pagevisited
            ? [...state.user.pagevisited, action.page]
            : [action.page],
        },
      }
    }
    default:
      return state
  }
}
